import { useState } from 'react'

import { OcrLimitResult } from '@eastcoal/api/nexus/interface'
import { recognizeIdCardApi } from '@eastcoal/api/nexus/ocr/recognizeIdCard'

import { UploadOcr } from '@eastcoal/common/components/UploadOcr'

import { OCrHelp } from '../OcrHelp'

import idCardBackView from './assets/idCardBack.webp'
import idCardFrontView from './assets/idCardFront.webp'
import { IdCardOcrProps } from './interface'

const createIdCardOcr = (front: boolean) => {
  return function IdCardOcr({
    height = 174,
    width = 280,
    ...restProps
  }: IdCardOcrProps) {
    const [limit, setLimit] = useState<OcrLimitResult>({
      rest: 0,
      total: 0
    })

    const title = front ? '身份证人像面' : '身份证国徽面'

    const placeholderImg = front ? idCardFrontView : idCardBackView

    return (
      <UploadOcr
        {...restProps}
        help={<OCrHelp limit={limit} title={title} />}
        ocrApi={recognizeIdCardApi}
        imageStyle={{
          height,
          width
        }}
        onLimitChange={setLimit}
      >
        <img alt={title} src={placeholderImg} style={{ width, height }} />
      </UploadOcr>
    )
  }
}

export const OcrIdCard = {
  Front: createIdCardOcr(true),
  Back: createIdCardOcr(false)
}
